import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { transl } from '../main/transl';
import { mg } from '../mg/mg';

type IOcButtonProps = ButtonProps & {
	disabledText: string | React.ReactNode
	dialogCloseText?: string
	dialogCloseAction?: () => void
}

@observer export class OcButton extends React.Component<IOcButtonProps> {
	@observable open = false

	@action onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		if (this.props.disabled) {
			this.open = true;
		} else {
			const f = this.props.onClick;
			f && f(event);
		}
	}

	@action onClose = () => {
		this.open = false;
		const f = this.props.dialogCloseAction;
		f && f();
	}

	render() {
		const {children, disabled, disabledText, dialogCloseText, dialogCloseAction, style, onClick, ...rest} = this.props;
		//console.log('OcButton.render', disabled);
		const newStyle: React.CSSProperties = {...style, opacity: disabled ? '60%' : '100%'};
		const props = {...rest, style: newStyle, onClick: this.onClick};
		mg.assertTrue(!disabled || disabledText);

		return <>
			<Button {...props}>
				{children}
			</Button>
			<Dialog open={this.open} onClose={this.onClose}>
				<DialogTitle>{transl('hint')}</DialogTitle>
				<DialogContent>{disabledText}</DialogContent>
				<DialogActions><Button onClick={this.onClose} color="primary">{dialogCloseText || transl('ok')}</Button></DialogActions>
			</Dialog>
		</>;
	}
}
